require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./apis-and-microservices-managing-packages-with-npm-how-to-use-package-json-the-core-of-any-node-js-project-or-npm-package.json") })
        }
      }, "path---apis-and-microservices-managing-packages-with-npm-how-to-use-package-json-the-core-of-any-node-js-project-or-npm-package");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---apis-and-microservices-managing-packages-with-npm-how-to-use-package-json-the-core-of-any-node-js-project-or-npm-package!./.cache/json/apis-and-microservices-managing-packages-with-npm-how-to-use-package-json-the-core-of-any-node-js-project-or-npm-package.json
// module id = 1271
// module chunks = 231608221292675